import { useState } from "react";
import styles from "./aboutCard.module.css";
import {
  IconCircleCheck,
  IconEdit,
  IconFileDescription,
  IconX,
} from "@tabler/icons-react";
import { companyAdditionalInfo } from "../../../../services/clientCalls";
import { errorHandler } from "../../../../utils";
import Button from "../../Button/button";
import { Textarea } from "../../FormInput/input";

const EMPTY_ABOUT = "No description has been provided yet.";

const AboutCard = ({ profileData, getCompanyProfile }) => {
  const [editing, setEditing] = useState(false);
  const [draftText, setDraft] = useState("");
  const [load, setLoad] = useState(false);

  const handleEdit = () => {
    if (editing) {
      setEditing(false);
      setDraft("");
    } else {
      setDraft(profileData?.summary || "");
      setEditing(true);
    }
  };

  const handleUpdate = (e) => {
    e.preventDefault();
    handleSubmit();
    setEditing(false);
    setDraft("");
  };

  const handleSubmit = async () => {
    setLoad(true);
    try {
      const payload = {
        summary: draftText.trim(),
      };
      const res = await companyAdditionalInfo(payload);
      if (res.data) {
        getCompanyProfile();
      }
    } catch (error) {
      error?.response?.data
        ? errorHandler(error?.response?.data?.errors, "Error")
        : errorHandler(
            "Network error: Something went wrong, Please check your internet connection and try again.",
            "Error",
          );
    } finally {
      setLoad(false);
    }
  };


  return (
    <div className={styles.card} id="aboutCard">
      {/* Header */}
      <div className={styles.cardHeader}>
        <div className={styles.cardHeaderLeft}>
          <div className={styles.cardIcon}>
            <IconFileDescription aria-hidden="true" />
          </div>
          <div>
            <div className={styles.cardTitle}>About Company</div>
            <div className={styles.cardSubtitle}>
              Your company's public description
            </div>
          </div>
        </div>
        <div
          className={`${styles.btnGroup} ${editing ? styles.btnGroupEditing : ""}`}
        >
          {editing && (
            <Button
              variant="secondary"
              leftIcon={<IconCircleCheck size={14} />}
              size="sm"
              onClick={handleUpdate}
              disabled={load}
              loading={load}
            >
              Update
            </Button>
          )}
          <Button
            leftIcon={editing ? <IconX size={14} /> : <IconEdit size={14} />}
            size="sm"
            onClick={handleEdit}
          >
            {editing ? "Cancel" : "Edit"}
          </Button>
        </div>
      </div>

      {/* Body */}
      <div className={styles.cardBody}>
        {!editing ? (
          <p
            className={`${styles.aboutText} ${!profileData?.summary ? styles.aboutTextEmpty : ""}`}
            id="aboutText"
          >
            {profileData?.summary || EMPTY_ABOUT}
          </p>
        ) : (
          <>
            <Textarea
              label="About Company"
              id="about"
              maxLength={500}
              value={draftText}
              onChange={(e) => setDraft(e.target.value)}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default AboutCard;
